<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h2 class="island">
          {{ lang.get('judging.fast_start.scoring.title') }}
        </h2>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="panel panel-default">
          <div class="panel-body">
            <div class="panel-title">
              {{ lang.get('judging.fast_start.scoring.scoring_criteria') }}
            </div>
            <div
              v-for="criterion in scoringCriteria"
              :key="'scoring-criterion-' + criterion.id"
              class="islet"
            >
              <a
                v-if="configuredCriterion !== criterion.id"
                href
                @click.prevent="
                  event => configureScoringCriterion(criterion.id)
                "
              >
                {{ criterionLabel(criterion) }}
              </a>
              <span v-else>{{ criterionLabel(criterion) }}</span>
              <div class="pull-right">
                <a
                  href
                  class="deleter-action"
                  @click.prevent="event => onDelete(criterion)"
                >
                  <icon name="close-circle" class="fs-130" />
                </a>
              </div>
            </div>
            <button
              v-if="!configuredCriterion"
              class="btn btn-primary"
              @click="onNewCriterionClick"
            >
              {{ lang.get('judging.fast_start.scoring.new') }}
            </button>
          </div>
        </div>
        <scoring-criterion
          v-if="!!configuredCriterion"
          :key="'scoring-criterion-' + configuredCriterion"
          :criterion-id="configuredCriterion"
          :routes="routes"
          @saved="onSave"
        />
      </div>
      <div class="col-xs-12 col-md-6">
        <scoring-preview :language="language"></scoring-preview>
      </div>
    </div>
    <navigation :disabled="configuredCriterion !== null" v-on="$listeners" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import Icon from '@/lib/components/Shared/Icon';
import Navigation from '../Navigation';
import ScoringCriterion from './ScoringCriterion';
import ScoringPreview from './ScoringPreview';

export default {
  inject: ['lang'],
  components: {
    Icon,
    Navigation,
    ScoringCriterion,
    ScoringPreview
  },
  props: {
    language: {
      type: String,
      default: 'en_GB'
    },
    scoringCriterionTemplate: {
      type: Object,
      default: () => ({})
    },
    routes: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('judgingFastStart', [
      'scoringCriteria',
      'scoreSets',
      'configuredCriterion'
    ]),
    ...mapGetters('judgingFastStart', ['scoreSetId'])
  },
  methods: {
    ...mapState('global', ['supportedLanguages']),
    ...mapMutations('judgingFastStart', [
      'configureScoringCriterion',
      'addScoringCriterion',
      'deleteScoringCriterion'
    ]),
    onNewCriterionClick() {
      const id = 'new-' + Date.now();
      const template = JSON.parse(
        JSON.stringify(this.scoringCriterionTemplate)
      );

      this.addScoringCriterion({
        ...template,
        id: id,
        scoresetId: this.scoreSetId
      });

      this.configureScoringCriterion(id);
    },
    onSave() {
      this.configureScoringCriterion(null);
    },
    onDelete(criterion) {
      this.configureScoringCriterion(null);
      this.deleteScoringCriterion(criterion);
    },
    criterionLabel(criterion) {
      const label = criterion.translated[this.language]['label'];
      return label || '-';
    }
  }
};
</script>
